/*
  React Native Components
*/
import React, { PureComponent } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

/*
  Custom Components
*/
import Pages from './pages';
import {routesProvider} from './config/app-config';
import Wrapper from './hoc/Wrapper';
import withLayout from './hoc/withLayout';
import PrivateRoute from './hoc/PrivateRoute';
import { userAuthContext } from './context/userAuthContext';

class App extends PureComponent {
  state = {
    isUserAuthenticated: false,
    loginAttempted: false,
    allowedServices: {},
    currentLoginSession: 'SAML' //Default
  }

  render() {
    return (
      <BrowserRouter basename={routesProvider.basename}>
        <userAuthContext.Provider value={{
            state: this.state,
            setAuthentication: (authResponse) => this.setState({ isUserAuthenticated: authResponse }),
            setLoginAttempt: (loginAttemptedFlag) => this.setState({ loginAttempted: loginAttemptedFlag }),
            setCurrentLoginSession: (loginSession) => this.setState({ currentLoginSession: loginSession }),
            setAllowedServices: (allowedServices) => this.setState({ allowedServices }),
        }}>
          <Wrapper>
            <Switch>
              {
                routesProvider.pages.map((page) => {
                  const PageComponent = withLayout(Pages[page.pageTemplate]);
                  const routeArgs = {
                    path: page.path,
                    exact: page.exact,
                    basename: routesProvider.basename,
                    component: () => (
                      <PageComponent
                        from={page.id}
                        title={page.title}
                        description={page.description}
                        info={page.info}
                        showUploadCard={page.showUploadCard}
                      />
                    )
                  };

                  // If its a Public page, then use the normal router, else route it via PrivateRouter which authenticates user
                  return !page.restricted
                    ? <Route key={page.title} {...routeArgs} />
                    : <PrivateRoute key={page.title} {...routeArgs} />
                })
              }
            </Switch>
          </Wrapper>
        </userAuthContext.Provider>
      </BrowserRouter>
    )
  }
}

export default App;
